import { averageOther762FMJ } from '../projectiles';

export const mgs = Object.freeze({
  'BAR A2': {
    name: 'BAR A2',
    list: 'mgs',
    calibre: '30-06',
    qty: 1,
    length: 48,
    baseWeight: 17.9,
    rt: 8,
    rof: '*4',
    mag: [{ type: 'Mag', weight: 1.8, cap: 20, qty: 0 }],
    kd: 10,
    sab: 4,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 13],
      mod: [-27, -17, -11, -9, -7, -6, -5, -4, -3, -1, 1],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [20, 19, 18, 16, 15, 11, 8.1, 6.0],
        dc: [8, 8, 8, 7, 7, 7, 6, 6],
      },
    ],
    ma: [0.3, 0.5, 1, 2, 3, 5, 8, 10],
    ba: [62, 54, 45, 38, 33, 24, 18, 14],
    tof: [0, 0, 1, 2, 2, 5, 8, 12],
    offical: true,
    bipod: true,
    selector: 'Full Auto Only',
  },
  'M1919 A6': {
    name: 'M1919 A6',
    list: 'mgs',
    calibre: '30-06',
    qty: 1,
    length: 53,
    baseWeight: 32.5,
    rt: 12,
    rof: '*4',
    mag: [{ type: 'Blt', weight: 15.5, cap: 250, qty: 0 }],
    kd: 11,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      mod: [-33, -23, -17, -12, -9, -7, -6, -4, -3, -2, -1],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [22, 21, 20, 18, 17, 13, 9.3, 6.9],
        dc: [8, 8, 8, 7, 7, 7, 6, 6],
      },
    ],
    ma: [0.2, 0.4, 0.7, 1, 2, 4, 5, 7],
    ba: [62, 54, 45, 38, 33, 24, 18, 14],
    tof: [0, 0, 1, 2, 2, 5, 8, 11],
    offical: true,
    bipod: true,
    selector: 'Full Auto Only',
  },
  'M1924/29': {
    name: 'M1924/29',
    list: 'mgs',
    calibre: '7.5mm Mle 29',
    qty: 1,
    length: 43,
    baseWeight: 19.6,
    rt: 8,
    rof: '*4',
    mag: [{ type: 'Mag', weight: 1.9, cap: 25, qty: 0 }],
    kd: 9,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 13],
      mod: [-28, -18, -11, -9, -7, -6, -5, -4, -3, -1, 1],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [18, 17, 17, 15, 14, 9.8, 7, 5.1],
        dc: [8, 7, 7, 7, 7, 6, 6, 4],
      },
    ],
    ma: [0.2, 0.4, 0.8, 1, 2, 4, 6, 8],
    ba: [61, 53, 44, 37, 32, 23, 17, 13],
    tof: [0, 0, 1, 2, 2, 5, 8, 12],
    offical: true,
    bipod: true,
  },
  M60: {
    name: 'M60',
    list: 'mgs',
    calibre: '7.62mm NATO',
    qty: 1,
    length: 44,
    baseWeight: 23.2,
    rt: 12,
    rof: '*5',
    mag: [{ type: 'Blt', weight: 6.5, cap: 100, qty: 0 }],
    kd: 10,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      mod: [-30, -20, -14, -10, -8, -6, -5, -4, -3, -2, 0],
    },
    projectiles: [averageOther762FMJ],
    ma: [0.3, 0.5, 1, 2, 3, 5, 8, 10],
    ba: [61, 53, 45, 37, 32, 23, 17, 13],
    tof: [0, 0, 1, 2, 2, 5, 8, 11],
    offical: true,
    bipod: true,
    selector: 'Full Auto Only',
  },
  M249: {
    name: 'M249',
    list: 'mgs',
    calibre: '5.56mm NATO',
    qty: 1,
    length: 41,
    baseWeight: 15.1,
    rt: 14,
    rof: '*7',
    mag: [{ type: 'Blt', weight: 6.9, cap: 200, qty: 0 }],
    kd: 4,
    sab: 2,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
      mod: [-28, -18, -11, -9, -7, -6, -4, -3, -2, -1, 0],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [15, 15, 14, 12, 11, 7, 4.6, 3],
        dc: [8, 8, 8, 7, 7, 7, 6, 5],
      },
    ],
    ma: [0.2, 0.3, 0.7, 1, 2, 3, 5, 7],
    ba: [61, 53, 44, 37, 32, 22, 17, 13],
    tof: [0, 0, 1, 2, 2, 5, 8, 11],
    offical: true,
    bipod: true,
  },
  RPD: {
    name: 'RPD',
    list: 'mgs',
    calibre: '7.62 x 39mm',
    qty: 1,
    length: 41,
    baseWeight: 16.7,
    rt: 14,
    rof: '*6',
    mag: [{ type: 'Drm', weight: 5.3, cap: 100, qty: 0 }],
    kd: 7,
    sab: 2,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
      mod: [-28, -18, -11, -9, -7, -6, -5, -4, -3, -2, 0],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [11, 10, 9.4, 8.2, 7.2, 4.6, 3.0, 1.9],
        dc: [7, 7, 6, 6, 6, 5, 3, 2],
      },
    ],
    ma: [0.2, 0.5, 0.9, 2, 2, 5, 7, 9],
    ba: [58, 50, 40, 33, 28, 18, 13, 9],
    tof: [0, 1, 1, 2, 3, 6, 10, 15],
    offical: true,
    bipod: true,
    selector: 'Full Auto Only',
  },
  RPK: {
    name: 'RPK',
    list: 'mgs',
    calibre: '7.62 x 39mm',
    qty: 1,
    length: 41,
    baseWeight: 11.1,
    rt: 10,
    rof: '*6',
    mag: [{ type: 'Drm', weight: 4.6, cap: 75, qty: 0 }],
    kd: 7,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
      mod: [-26, -16, -10, -8, -7, -5, -4, -3, -2, -1, 0],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [12, 11, 10, 9.1, 7.9, 5.1, 3.3, 2.1],
        dc: [7, 7, 7, 6, 6, 5, 3, 2],
      },
    ],
    ma: [0.3, 0.5, 1, 2, 3, 5, 8, 10],
    ba: [58, 50, 41, 33, 28, 18, 13, 9],
    tof: [0, 1, 1, 2, 3, 6, 10, 14],
    offical: true,
    bipod: true,
  },
  'RPK 74': {
    name: 'RPK 74',
    list: 'mgs',
    calibre: '5.45 x 39.5mm',
    qty: 1,
    length: 45,
    baseWeight: 9.9,
    rt: 8,
    rof: '*5',
    mag: [{ type: 'Mag', weight: 1.5, cap: 40, qty: 0 }],
    kd: 4,
    sab: 2,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      mod: [-24, -14, -10, -8, -6, -5, -4, -3, -2, -1, 0],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [17, 16, 15, 13, 12, 7.5, 4.9, 3.2],
        dc: [6, 6, 6, 6, 5, 4, 3, 2],
      },
    ],
    ma: [0.2, 0.4, 0.8, 1, 2, 4, 6, 8],
    ba: [61, 52, 44, 36, 31, 22, 16, 12],
    tof: [0, 0, 1, 1, 2, 4, 7, 10],
    offical: true,
    bipod: true,
  },
  PKM: {
    name: 'PKM',
    list: 'mgs',
    calibre: '7.62 x 54mm',
    qty: 1,
    length: 46,
    baseWeight: 19.8,
    rt: 12,
    rof: '*6',
    mag: [{ type: 'Blt', weight: 5.7, cap: 100, qty: 0 }],
    kd: 12,
    sab: 4,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
      mod: [-29, -19, -12, -9, -7, -6, -5, -4, -3, -2, 0],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [23, 22, 21, 19, 18, 13, 10, 7.7],
        dc: [8, 8, 8, 8, 8, 7, 7, 6],
      },
    ],
    ma: [0.4, 0.8, 2, 3, 4, 8, 12, 16],
    ba: [63, 56, 48, 41, 36, 27, 21, 17],
    tof: [0, 0, 1, 2, 2, 5, 8, 11],
    offical: true,
    bipod: true,
    selector: 'Full Auto Only',
  },
  DP: {
    name: 'DP',
    list: 'mgs',
    calibre: '7.62 x 54mm',
    qty: 1,
    length: 51,
    baseWeight: 19.5,
    rt: 10,
    rof: '*5',
    mag: [{ type: 'Pan', weight: 3.3, cap: 47, qty: 0 }],
    kd: 12,
    sab: 4,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
      mod: [-28, -18, -12, -9, -7, -6, -5, -4, -3, -2, 0],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [24, 24, 22, 21, 19, 15, 12, 9.4],
        dc: [8, 8, 8, 8, 8, 7, 7, 6],
      },
    ],
    ma: [0.3, 0.7, 1, 2, 3, 7, 10, 13],
    ba: [63, 56, 48, 41, 36, 27, 21, 17],
    tof: [0, 0, 1, 2, 2, 5, 8, 11],
    offical: true,
    bipod: true,
    selector: 'Full Auto Only',
  },
});
